import AgreementTypeCreationPage from "./AgreementTypeCreationPage";

export default AgreementTypeCreationPage;